import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BookPickupComponent } from './book-pickup/book-pickup.component';
import { PickupListComponent } from './pickup-list/pickup-list.component';
import { CancelPickupComponent } from './cancel-pickup/cancel-pickup.component';
import { MatSliderModule } from '@angular/material/slider';
@NgModule({
  declarations: [PickupListComponent, BookPickupComponent, CancelPickupComponent],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatSliderModule,
  ],
})
export class PickupModule {}
